import {Component, Input} from '@angular/core'
import {isNullOrUndefined} from "util";

@Component({
    selector: 'panel',
    template: require('./panel.template.html')
})
export class Panel {

    @Input('title') public title: string;

    isTitleDefined(): boolean {
        return !isNullOrUndefined(this.title);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/panel/panel.component.ts